export const PRODUCT_MUTATIONS = {
  // Loading state
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',

  // Categories
  SET_CATEGORIES: 'SET_CATEGORIES',
  SET_FILTERED_CATEGORIES: 'SET_FILTERED_CATEGORIES',

  // Brands
  SET_BRANDS: 'SET_BRANDS',
  SET_FILTERED_BRANDS: 'SET_FILTERED_BRANDS',

  // Properties
  SET_COLORS: 'SET_COLORS',
  SET_SIZES: 'SET_SIZES',

  // Products
  SET_PRODUCTS: 'SET_PRODUCTS',
  SET_FILTERED_PRODUCTS: 'SET_FILTERED_PRODUCTS',
  SET_PRODUCT_ASSETS: 'SET_PRODUCT_ASSETS',

  // Selected values
  SET_SELECTED_CATEGORY_ID: 'SET_SELECTED_CATEGORY_ID',
  SET_SELECTED_BRAND_ID: 'SET_SELECTED_BRAND_ID',
  SET_SELECTED_PARENT_ID: 'SET_SELECTED_PARENT_ID',
  SET_SELECTED_ORIGINAL_ID: 'SET_SELECTED_ORIGINAL_ID',

  // Product info
  UPDATE_PRODUCT_INFO: 'UPDATE_PRODUCT_INFO',
  SET_PRODUCT_INFO: 'SET_PRODUCT_INFO',

  // Product options
  SET_PRODUCT_OPTIONS: 'SET_PRODUCT_OPTIONS',

  // Child products
  SET_CHILD_PRODUCTS: 'SET_CHILD_PRODUCTS',
  ADD_CHILD_PRODUCT: 'ADD_CHILD_PRODUCT',
  UPDATE_CHILD_PRODUCT: 'UPDATE_CHILD_PRODUCT',
  REMOVE_CHILD_PRODUCT: 'REMOVE_CHILD_PRODUCT',

  // Combo products
  SET_COMBO_PRODUCTS: 'SET_COMBO_PRODUCTS',
  ADD_COMBO_PRODUCT: 'ADD_COMBO_PRODUCT',
  UPDATE_COMBO_PRODUCT: 'UPDATE_COMBO_PRODUCT',
  REMOVE_COMBO_PRODUCT: 'REMOVE_COMBO_PRODUCT',
  TOGGLE_COMBO_PRODUCT_EDIT: 'TOGGLE_COMBO_PRODUCT_EDIT',

  // Product history
  SET_PRODUCT_HISTORY: 'SET_PRODUCT_HISTORY',
  SET_PRODUCT_HISTORY_LOADING: 'SET_PRODUCT_HISTORY_LOADING',
};
